import { createFileRoute, redirect } from "@tanstack/react-router";

/** @public */
export const Route = createFileRoute("/_auth/help/")({
    beforeLoad: () => {
        throw redirect({ to: "/help/messages" });
    },
});
